// Animation on scroll — uses IntersectionObserver (no scroll/resize listeners)
function initAnimation() {
  const elems = document.querySelectorAll('[data-animate]:not([data-animated])');

  if (!elems.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.setAttribute('data-animated', '');
          observer.unobserve(entry.target);
        }
      });
    },
    // rootMargin '-10% bottom' mirrors the original `windowHeight * 0.90` threshold
    { threshold: 0, rootMargin: '0px 0px -10% 0px' }
  );

  elems.forEach((el) => observer.observe(el));
}

document.addEventListener('DOMContentLoaded', initAnimation);
document.addEventListener('animation:init', initAnimation);
